var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.timeText != '无')?_c('div',{staticClass:"countdown"},[_c('div',{staticClass:"text"},[_vm._v("下次提醒 "+_vm._s(_vm.timeText))]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm._f("filterTime")(_vm.changeTime)))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }